import { render } from "./header.vue?vue&type=template&id=4cf23697&scoped=true"
import script from "./header.vue?vue&type=script&lang=js"
export * from "./header.vue?vue&type=script&lang=js"

import "./header.vue?vue&type=style&index=0&id=4cf23697&scoped=true&lang=scss"

import exportComponent from "/builds/septacodeprojects/septacode.com/frontend/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cf23697"]])

export default __exports__